import { render } from "./ButtonUI.vue?vue&type=template&id=38f28932"
import script from "./ButtonUI.vue?vue&type=script&lang=js"
export * from "./ButtonUI.vue?vue&type=script&lang=js"

import "./ButtonUI.vue?vue&type=style&index=0&id=38f28932&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__